import { Meta } from '@solidjs/meta';
import { AccessProductsCtx, createAsyncSubscriptionProducts } from '../../providers/card';
import { getConfigValue } from '../../modules/config';
import type { RouteDefinition, RouteSectionProps } from '@solidjs/router';

export default function CardsPageLayout(props: RouteSectionProps) {
	const data = createAsyncSubscriptionProducts();

	return (
		<>
			<Meta name="og:image" content={`${getConfigValue('IMAGE_HOST')}/og/membership.jpg`} />
			<AccessProductsCtx.Provider value={data}>{props.children}</AccessProductsCtx.Provider>
		</>
	);
}

export const route = { info: { banner: { hide: true } } } satisfies RouteDefinition;
